import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visibleWhen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ShowMoreOrdersButton = function ShowMoreOrdersButton(_ref) {
  var visibleWhen = _ref.visibleWhen,
    props = _objectWithoutProperties(_ref, _excluded);
  if (visibleWhen === false) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ResponsiveButton, _objectSpread({
    variant: "tertiary"
  }, props), /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rByBk0",
    defaultMessage: [{
      "type": 0,
      "value": "Mostra altri ordini"
    }]
  }));
};
var ResponsiveButton = styled(Button).withConfig({
  displayName: "ShowMoreOrdersButton__ResponsiveButton"
})(["", "{width:100%;}"], responsiveMediaQueries.mobile);